import { useAppSelector } from 'hooks';
import { activeFormatSelector } from 'selectors/drawers';

import './index.scss';

type AcademicYearContentProps = {
  children: React.ReactNode | React.ReactNode[];
};

const FormatGrid = ({ children }: AcademicYearContentProps) => {
  const format = useAppSelector(activeFormatSelector);
  return <div className={`format-grid ${format === 'horizontal' ? 'format-grid--horizontal' : ''}`}>{children}</div>;
};

export default FormatGrid;
